import { DateUtil } from '@utils'
import { IProjectionImport } from '@api'

type GetImportInfoData = {
  createdAt: IProjectionImport['createdAt']
  importedBy: IProjectionImport['importedBy']
}

export const getImportInfo = (data: GetImportInfoData): string =>
  data.createdAt && `${DateUtil(data.createdAt).format('MMM d, yyyy @h:mma')} by ${data.importedBy}`
